import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { GoogleMapsApi } from 'src/app/models/google-maps.model';
import { environment } from 'src/environments/environment';

declare global {
  interface Window {
    __bisualGoogleMapsInit?: () => void;
    google?: GoogleMapsApi;
  }
}

@Injectable({
  providedIn: 'root',
})
export class GoogleMapsLoaderService {
  private readonly document = inject(DOCUMENT);

  private load_promise: Promise<GoogleMapsApi> | null = null;

  load(): Promise<GoogleMapsApi> {
    if (window.google?.maps?.places != null) {
      return Promise.resolve(window.google);
    }

    if (this.load_promise != null) {
      return this.load_promise;
    }

    const api_key = environment.google_maps_api_key.trim();

    if (api_key === '') {
      return Promise.reject(new Error('No se ha configurado la clave de Google Maps.'));
    }

    this.load_promise = new Promise<GoogleMapsApi>((resolve, reject) => {
      window.__bisualGoogleMapsInit = (): void => {
        if (window.google == null) {
          this.load_promise = null;
          reject(new Error('Google Maps no está disponible.'));
          return;
        }

        resolve(window.google);
      };

      const script = this.document.createElement('script');
      const params = new URLSearchParams({
        key: api_key,
        libraries: 'places',
        callback: '__bisualGoogleMapsInit',
        loading: 'async',
      });

      script.id = 'google-maps-api-script';
      script.async = true;
      script.defer = true;
      script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
      script.onerror = (): void => {
        this.load_promise = null;
        reject(new Error('No se pudo cargar Google Maps.'));
      };

      this.document.head.appendChild(script);
    });

    return this.load_promise;
  }
}
